<template>
  <div id="createVideo" class="letters">
    <v-container class="pa-0">
      <v-layout>
        <v-flex class="xs12 sm12 mb-5">
          <v-btn fab absolute left to="/videos" class="ml-3 pf-btn-fab">
            <v-icon>arrow_back</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container>
      <v-flex v-if="currentAlbum !== null" flat class="xs6 text-xs-left pt-3 pl-3">
        <span class="title font-weight-Bold custom-title">Selected Album</span>
      </v-flex>
      <p class="ml-3" v-if="!selectedAlbums.length">No albums/photos selected</p>
      <v-card class="ma-3" v-if="currentAlbum !== null">
        <v-layout row wrap>
          <v-flex flat class="xs6 text-xs-left pl-3 pt-2">
            <span class="custom-title">{{`Title: ${selectedAlbums[currentAlbum].name}`}}</span>
          </v-flex>
        </v-layout>
        <v-layout row wrap class="xs12 text-xs-center">
          <v-flex xs12 class="mb-1">
              <v-switch
                  v-model="selectAll"
                  :value="selectedAlbums[currentAlbum].id"
                  @change="selectAllPhotos(selectedAlbums[currentAlbum])"
                  label="Select All"
                  class="pr-4 pl-3 mt-0">
              </v-switch>
          </v-flex>
        </v-layout>
        <draggable class="layout pa-2 xs12 text-xs-center row wrap" v-model="selectedAlbums[currentAlbum].photo" @start="drag=true" @end="drag=false; updateFinalAlbumList()" handle=".handle_photo">
          <v-flex v-for="(photo, j) of selectedAlbums[currentAlbum].photo" :key="j" xs4 sm3 md2 lg1 pa-1>
              <v-card flat tile v-if="photo" class="positionrel pf-cursor-pointer">
                <div class="image_thumb" :style="`background-image: url('${photo.thumb_url}');`" :imgid="photo.id" @click="selectImage(selectedAlbums[currentAlbum], photo)"></div>
                <div class="d-flex align-center justify-center positionabs imgfade clickable" v-if="userSelectedImages.indexOf(photo.id) !== -1">
                    <v-icon size="22" title="Unselect" color="white darken-2" @click="unSelectImage(selectedAlbums[currentAlbum].id, photo.id)">check</v-icon>
                    <v-icon size="22" title="Reorder" class="handle_photo" color="white darken-2">drag_indicator</v-icon>
                </div>
              </v-card>
          </v-flex>
        </draggable>
      </v-card>
      <v-flex flat class="pa-2" v-if="finalAlbumList.length">
        <span class="title font-weight-Bold ml-2 custom-title">Layout</span><br/>
        <small class="ml-2">Below is the timeline for video</small>
        <v-card class="ma-2 d-flex grey lighten-5 max-height-500-scroll-y">
          <v-layout wrap row class="pa-3">
            <v-flex class="text-xs-center xs6 sm4 md3 lg2">
              <v-card flat tile class="positionrel pf-cursor-pointer">
                <div class="image_thumb d-flex align-center justify-center">{{ Account.name }}</div>
              </v-card>
            </v-flex>
            <draggable v-model="selectedAlbums" handle=".handle" class="container pa-0" @start="drag=true" @end="drag=false; updateFinalAlbumList()" forceFallback= "false">
              <template v-for="(album, i) in finalAlbumList">
                <v-card :key="i" class="layout pf-relative wrap pf-full-width mt-3 pa-2" @click="setCurrentAlbum(album)">
                  <v-btn icon absolute class="teal handle drag-icon" title="Re-order" v-if="selectedAlbums.length > 1">
                    <v-icon size="15" color="white">open_with</v-icon>
                  </v-btn>
                  <v-flex class="pa-1 text-xs-center xs6 sm4 md3 lg2">
                    <v-card flat tile class="positionrel pf-cursor-pointer">
                      <div class="image_thumb d-flex align-center justify-center">{{ album.name }}</div>
                    </v-card>
                  </v-flex>
                  <v-flex v-for="(photo) in album.photo" :key="photo.id" class="pa-1 text-xs-center xs4 sm3 md2 lg1">
                    <v-card flat tile class="positionrel pf-cursor-pointer">
                      <div class="image_thumb" :style="`background-image: url('${photo.thumb_url}');`"></div>
                    </v-card>
                  </v-flex>
                </v-card>
              </template>
            </draggable>
            <v-flex class="pt-3 text-xs-center xs6 sm4 md3 lg2">
              <v-card flat tile class="positionrel pf-cursor-pointer">
                <div class="d-flex image_thumb align-center justify-center">
                  <!-- <span>Contact Agency: {{ Account.default_agency.name || 'Unknown' }}</span>
                  <span v-if="Account.default_agency.email && Account.default_agency.email.length">Email: {{ Account.default_agency.email[0].email }}</span>
                  <span v-if="Account.default_agency.phone && Account.default_agency.phone.length">Phone: {{ Account.default_agency.phone[0].country_code }} {{ Account.default_agency.phone[0].number }}</span> -->
                  <span>Agency Contact Info</span>
                </div>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-stepper v-model="eleStep" class="ma-3">
        <v-stepper-header>
          <v-stepper-step :complete="eleStep > 1" step="1">Albums</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="eleStep > 2" step="2">Inserts</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="eleStep > 3" step="3">Configuration</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step step="4">Submit</v-stepper-step>
        </v-stepper-header>
        <v-stepper-items>
          <v-stepper-content step="1">
            <v-flex offset-xs6 xs6 class="text-xs-right">
              <div class="d-inline-flex">
              <v-btn class="pf-btn pf-btn-save mt-3" @click="eleStep = 2" :disabled="finalAlbumList.length === 0 ? true : false">
                <v-icon size="16" class="pr-1">arrow_forward</v-icon>
                <div>Next</div>
              </v-btn>
              </div>
            </v-flex>
            <v-card class="ml-1 mr-1 mt-2 pa-3 mb-2">
              <v-card-title v-if="!albumList.length" class="justify-center">
                <span class="title">No albums avaliable</span>
              </v-card-title>
              <v-layout wrap row class="ml-2">
                <v-flex xs12 class="mb-3">
                    <v-switch
                        v-model="selectAllAlbumsVar"
                        @change="selectAllAlbums()"
                        label="Select All"
                        class="mt-0">
                    </v-switch>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="xs12 text-xs-center max-height-500-scroll-y">
                <template v-for="albumItem of albumList">
                  <v-flex :key="albumItem.id" xs6 sm3 md2 pa-2 v-if="albumItem.type === 'Normal' && albumItem.photo.length && albumItem.default_photo && albumItem.photo.length">
                    <v-card class="clickable">
                        <v-card flat tile class="positionrel pf-cursor-pointer">
                          <div class="album_thumb" @click="addAlbum(albumItem);photosListCard = true;" :style="`background-image: url('${albumItem.default_photo.thumb_url}');`" ></div>
                          <div class="positionabs imgfade clickable" @click="removeAlbum(albumItem)" v-if="selectedAlbums.findIndex(album => album.id === albumItem.id) > -1">
                              <v-icon size="30" title="Unselect" class="pr-1 pl-3" color="white darken-2">check</v-icon>
                          </div>
                        </v-card>
                        <v-flex class="pl-1 pr-1 mb-0">
                        <h5
                            id="albumName"
                            class="pa-1 title-display">
                        <div>
                            <span v-if="albumItem.name">{{ albumItem.name }}</span>
                            <span v-else>Untitled</span>
                        </div>
                        </h5>
                        </v-flex>
                    </v-card>
                  </v-flex>
                </template>
              </v-layout>
            </v-card>
            <v-layout wrap row>
              <v-flex offset-xs6 xs6 class="text-xs-right">
                <div class="d-inline-flex">
                <v-btn class="pf-btn pf-btn-save mt-2" @click="eleStep = 2" :disabled="finalAlbumList.length === 0 ? true : false">
                  <v-icon size="16" class="pr-1">arrow_forward</v-icon>
                  <div>Next</div>
                </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-stepper-content>
          <v-stepper-content step="2">
            <v-flex flat class="text-xs-left pa-1">
              <span class="title font-weight-bold custom-title">Text Slides</span>
            </v-flex>
            <v-layout row wrap class="pb-4 xs12 text-xs-center">
              <v-flex class="pa-1 text-xs-center xs6 sm4 md3 lg2">
                <v-card flat tile class="positionrel pf-cursor-pointer">
                  <div class="image_thumb d-flex align-center justify-center">{{ Account.name }}</div>
                </v-card>
                <small>First Slide</small>
              </v-flex>
              <v-flex class="pa-1 text-xs-center xs6 sm4 md3 lg2">
                <v-card flat tile class="positionrel pf-cursor-pointer">
                  <div class="image_thumb d-flex align-center justify-center">Contact Info</div>
                </v-card>
                <small>Last Slide</small>
              </v-flex>
            </v-layout>
            <v-flex flat class="text-xs-left pa-1">
              <span class="title font-weight-bold custom-title">Keywords</span>
            </v-flex>
            <v-layout row wrap class="pb-4 xs12 text-xs-center">
              <v-flex class="pa-1">
                <v-combobox v-model="keywords" :items="keywords" label="Keywords - hit enter to add new" multiple deletable-chips small-chips></v-combobox>
              </v-flex>
            </v-layout>
            <v-layout wrap row>
              <v-flex offset-xs6 xs6 class="text-xs-right">
                <div class="d-inline-flex">
                  <v-btn class="pf-btn pf-btn-cancel" @click="eleStep = 1">
                    <v-icon size="16" class="pr-1">arrow_back</v-icon>
                    <div>Previous</div>
                  </v-btn>
                  <v-btn class="pf-btn pf-btn-save mr-0" @click="eleStep = 3" :disabled="false">
                    <v-icon size="16" class="pr-1">arrow_forward</v-icon>
                    <div>Next</div>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-stepper-content>
          <v-stepper-content step="3">
            <v-layout wrap row>
              <v-flex offset-xs6 xs6 class="text-xs-right">
                <div class="d-inline-flex">
                  <v-btn class="pf-btn pf-btn-cancel" @click="eleStep = 2">
                    <v-icon size="16" class="pr-1">arrow_back</v-icon>
                    <div>Previous</div>
                  </v-btn>
                  <v-btn class="pf-btn pf-btn-save mr-0" @click="eleStep = 4" :disabled="!music && !uploadedMusic">
                    <v-icon size="16" class="pr-1">arrow_forward</v-icon>
                    <div>Next</div>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
            <v-card class="ml-1 mr-1 mt-2 pa-3 mb-3">
              <v-flex flat class="xs6 text-xs-left pa-3" v-if="Music.length">
                <span class="title font-weight-bold custom-title">Choose from library</span>
              </v-flex>
              <v-layout row wrap class="pb-4 xs12 text-xs-center">
                <template v-for="(audio, i) in Music">
                  <v-flex v-if="audio.file" :key="i" class="pa-1 text-xs-center xs12 sm4">
                    <v-card flat tile class="positionrel pf-cursor-pointer border-radius-25 flex-column-center pa-2">
                      <audio controls>
                        <source :src="`${ config.uploadPath }${ audio.file.webPath }`" :type="audio.file.mimetype">
                        Your browser does not support the audio element.
                      </audio>
                      <v-checkbox
                        v-model="music"
                        :label="audio.name"
                        :value="audio.id"
                        class="mt-1"
                      ></v-checkbox>
                    </v-card>
                  </v-flex>
                </template>
              </v-layout>
              <v-layout row wrap class="xs12 text-xs-center flex-column">
                <h4 v-if="Music.length" class="text-xs-center font-weight-bold">OR</h4>
                <v-flex pa-2>
                  <upload-btn @file-update="fileSelected($event)" noTitleUpdate title="Upload Music" ripple maxWidth="200px">
                    <template slot="icon">
                        <v-icon right dark>cloud_upload</v-icon>
                    </template>
                    <template slot="text-field"></template>
                  </upload-btn>
                </v-flex>
              </v-layout>
            </v-card>
            <v-layout wrap row>
              <v-flex offset-xs6 xs6 class="text-xs-right">
                <div class="d-inline-flex">
                  <v-btn class="pf-btn pf-btn-cancel" @click="eleStep = 2">
                    <v-icon size="16" class="pr-1">arrow_back</v-icon>
                    <div>Previous</div>
                  </v-btn>
                  <v-btn class="pf-btn pf-btn-save mr-0" @click="eleStep = 4" :disabled="!music && !uploadedMusic">
                    <v-icon size="16" class="pr-1">arrow_forward</v-icon>
                    <div>Next</div>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-stepper-content>
          <v-stepper-content step="4">
            <v-card class="ml-1 mr-1 mt-2 pa-3 mb-3">
              <v-layout row wrap class="xs12 text-xs-center">
                <v-layout wrap class="pa-3">
                  <v-flex>
                    <v-btn :disabled="(!music && !uploadedMusic) || !finalAlbumList.length" color="pf-btn pf-btn-save" @click="createVideo">Create Video</v-btn>
                    <p v-if="(!music && !uploadedMusic) || !finalAlbumList.length" class="red--text">Please make sure you've selected atleast 1 photo and background music</p>
                  </v-flex>
                </v-layout>
              </v-layout>
            </v-card>
            <v-layout wrap row>
              <v-flex offset-xs6 xs6 class="text-xs-right">
                <div class="d-inline-flex">
                  <v-btn class="pf-btn pf-btn-cancel mr-0" @click="eleStep = 3">
                    <v-icon size="16">arrow_back</v-icon>
                    <div>Previous</div>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-container>
  </div>
</template>

<script>
/* global session router store config */
import { create, getCollection, sortList, updateSortList, getOne, uploadFile } from '../../helpers/helpers';
import UploadButton from 'vuetify-upload-button';
import swal from 'sweetalert2';
import { mapGetters } from 'vuex';
import goTo from 'vuetify/lib/components/Vuetify/goTo';
import draggable from 'vuedraggable';

// This is used to add new letters by the parents
export default {
  name: 'VideosCreation',
  components: {
    draggable,
    'upload-btn': UploadButton,
  },
  data: () => ({
    eleStep: 0,
    config: config,
    finalAlbumList: [],
    selectedAlbumList: [],
    finalObject: {},
    uploadingFile: {},
    music: null,
    uploadedMusic: null,
    fileName: '',
    userSelectedImages: [],
    // userSelectImages: false,
    photoList: [],
    photosListCard: false,
    selectAll: [],
    selectAllAlbumsVar: false,
    selectedAlbums: [],
    currentAlbum: null,
    keywords: [],
    textSlides: []
  }),
  computed: {
    ...mapGetters(['Album', 'AlbumPhoto', 'Account']),
    albumList: {
      get () {
        return store.state.Album.filter(item => (item.photo.length > 0));
      },
      set (value) {
        store.commit('setAlbum', value);
      }
    },
    Music: {
      get () {
        return store.state.Music;
      },
      set (value) {
        store.commit('setMusic', value);
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  created () {
    this.getAlbums();
    this.getMusic();
  },
  methods: {
    async createVideo () {
      this.finalObject = {
        account: this.Account.id,
        album: this.finalAlbumList,
        keywords: this.keywords,
        text_slides: this.textSlides
      };
      if (this.uploadedMusic) {
        this.finalObject.music = this.uploadedMusic;
      } else {
        let musicIndex = this.Music.findIndex(x => x.id === this.music);
        let music = this.Music[musicIndex];
        this.finalObject.music = music.file.webPath;
      }
      let { error, data } = await create('Video/Create', this.finalObject);
      if (error) {
        this.selectedData = true;
        console.log('error', error);
      } else {
        swal.fire({
          type: 'success',
          title: 'Video create request has been submitted, please check back soon.',
          showConfirmButton: false,
          timer: 3500,
          onClose: () => {
            this.$router.push({ path: '/videos' });
          }
        });
      }
    },
    async fileSelected (files) {
      this.uploadingFile = files;
      let type = '';
      if (this.uploadingFile) {
        type = this.uploadingFile.type.split('/')[0];
      }
      if (type === 'audio') {
        this.upload();
      } else {
        this.uploadingFile = {};
        swal.fire({
          title: `<strong>Invalid Format</strong>`,
          type: 'error',
          html: `Please upload audio file`,
          showCloseButton: true,
          showCancelButton: false,
          focusConfirm: false,
          confirmButtonText: 'Close',
        });
        return;
      }
    },
    async upload () {
      if (!this.uploadingFile.name) {
        swal.fire({
          title: `<strong>Upload error</strong>`,
          type: 'error',
          html: 'File is required',
          showCloseButton: true,
          showCancelButton: false,
          focusConfirm: false,
          confirmButtonText: 'Close',
        });
        return;
      }
      if (this.uploadingFile.name) {
        let errorHtml = null;
        let files = this.uploadingFile;
        if (files !== 'undefined') {
          this.fileName = files.name;
          if (this.fileName.lastIndexOf('.') <= 0) {
            return;
          }
          if (files.size > this.config.uploadFileSize) {
            errorHtml = 'Maximum file upload size is ' + (this.config.uploadFileSize / 1024 / 1024) + ' MB';
          }
          if (errorHtml) {
            swal.fire({
              title: `<strong>Upload Error</strong>`,
              type: 'error',
              html: errorHtml,
              showCloseButton: true,
              showCancelButton: false,
              focusConfirm: false,
              confirmButtonText: 'Close',
            });
            return;
          }
          window.getApp.$emit('AppProgress', true);
          const fr = new FileReader();
          fr.readAsDataURL(files);
          fr.addEventListener('load', async () => {
            let postUrl = 'Video/Create/AudioUpload';
            let extraParams = {
              type: 'VideoCreate',
              account: this.Account.id
            };
            if (session.getSession().adminUser) {
              extraParams.account = session.getSession().user.human.account.id;
            }
            let response = await uploadFile(postUrl, files, 'POST', extraParams);
            if (!response.$data) {
              window.getApp.$emit('AppProgress', false);
              console.log('error', response.$error);
              this.snackbar = {
                show: true,
                color: 'red',
                text: response.$error
              };
            } else {
              swal.fire({
                type: 'success',
                title: 'File uploaded successfully',
                showConfirmButton: false,
                timer: 2500,
                onClose: () => {
                  this.music = null;
                  this.uploadedMusic = response.$data.file.webPath;
                }
              });
            }
          });
        }
      }
    },
    async getMusic () {
      if (!this.Music.length) {
        let sort = { sort_no: 1 };
        let { error, data } = await getCollection('Music', true, 0, '', {}, null, null, sort);
        if (error) {
          console.log(error);
        } else {
          if (data.length > 0) {
            this.Music = data;
          }
        }
      }
    },
    async setCurrentAlbum (album) {
      this.currentAlbum = this.selectedAlbums.findIndex(x => x.id === album.id);
    },
    async selectAllPhotos (albumItem) {
      let addAll = this.selectAll.indexOf(albumItem.id);
      if (addAll > -1) {
        await this.addAlbum(albumItem);
      } else {
        let albumIndex = this.selectedAlbums.findIndex(album => album.id === albumItem.id);
        for (let index = 0; index < this.selectedAlbums[albumIndex].photo.length; index++) {
          this.userSelectedImages.splice(this.userSelectedImages.indexOf(this.selectedAlbums[albumIndex].photo[index].id), 1);
        }
        this.selectedAlbums.splice(albumIndex, 1);
        // Reset the current album
        if (this.currentAlbum !== null && albumIndex === this.currentAlbum) {
          this.currentAlbum = null;
        }
      }
      if (this.selectedAlbums.length === this.Album.filter(x => x.type === 'Normal' && x.photo.length).length) {
        this.selectAllAlbumsVar = true;
      } else {
        this.selectAllAlbumsVar = false;          
      }
      this.finalAlbumList = JSON.parse(JSON.stringify(this.selectedAlbums));
    },
    async selectAllAlbums () {
      if (this.selectAllAlbumsVar) {
        let normalAlbums = this.Album.filter(album => album.type === 'Normal' && album.photo.length);
        if (normalAlbums.length) {
          for (let i = 0; i < normalAlbums.length; i++) {
            let album = normalAlbums[i];
            await this.addAlbum(album);
          }
        }
      } else {
        this.selectedAlbums = [];
        this.finalAlbumList = [];
        this.userSelectedImages = [];
        this.currentAlbum = null;
      }
    },
    async updateFinalAlbumList () {
      let selectedItems = [];
      let album = {};
      let photo = {};
      for (let i = 0; i < this.selectedAlbums.length; i++) {
        album = this.selectedAlbums[i];
        let albumItem = {
          id: album.id,
          name: album.name,
          photo: []
        };
        if (album.photo && album.photo.length) {
          for (let j = 0; j < album.photo.length; j++) {
            photo = album.photo[j];
            if (this.userSelectedImages.indexOf(photo.id) > -1) {
              albumItem.photo.push({
                id: photo.id,
                caption: photo.caption ? photo.caption : '',
                thumb_url: photo.thumb_url,
                webview_url: photo.webview_url,
                original_url: photo.original_url
              });
            }
          }
        }
        selectedItems.push(albumItem);
      }
      this.finalAlbumList = selectedItems;
    },
    // @vuese
    // Used to fetch the album list if not exists
    async getAlbums () {
      let sessionUser = session.getSession();
      let where = sessionUser.adminUser ? { account: sessionUser.user.human.account.id } : {};
      if (!this.albumList.length) {
        let entity = 'Album';
        let { error, data } = await getCollection(entity, true, 0, '', where);
        if (error) {
          console.log('error', error);
        } else {
          if (data.length > 0) {
            this.albumList = sortList(entity, data, 'Account', sessionUser.adminUser ? sessionUser.user.human.account.id : 'Me');
          }
        }
      }
    },
    // @vuese
    // Used to fetch a single album along with its photos
    // @arg The album ID
    async addAlbum (albumItem) {

      await this.getPhotos(albumItem.id);
      let index = this.selectedAlbums.findIndex(album => album.id === albumItem.id);
      if (index === -1 && this.AlbumPhoto[albumItem.id]) {
        let album = {
          id: albumItem.id,
          name: albumItem.name,
          photo: []
        };
        for (let i = 0; i < this.AlbumPhoto[albumItem.id].length; i++) {
          let photo = this.AlbumPhoto[albumItem.id][i];
          photo = {
            id: photo.id,
            caption: photo.caption ? photo.caption : '',
            thumb_url: photo.thumb_url,
            webview_url: photo.webview_url,
            original_url: photo.original_url
          };
          album.photo.push(photo);
        }
        this.selectedAlbums.push(album);
      }
      // Push into userSelectedImages - Tracking the checked photos
      for (let i = 0; i < this.AlbumPhoto[albumItem.id].length; i++) {
        let photo = this.AlbumPhoto[albumItem.id][i];
        if (this.userSelectedImages.indexOf(photo.id) === -1) {
          this.userSelectedImages.push(photo.id);
        }
      }
      if (this.selectedAlbums.length === this.Album.filter(x => x.type === 'Normal' && x.photo.length).length) {
        this.selectAllAlbumsVar = true;
      } else {
        this.selectAllAlbumsVar = false;
      }
      index = this.selectedAlbums.findIndex(album => album.id === albumItem.id);
      if (this.AlbumPhoto[albumItem.id].length === this.selectedAlbums[index].photo.length) {
        this.selectAll.push(albumItem.id);
      }
      this.finalAlbumList = JSON.parse(JSON.stringify(this.selectedAlbums));
    },

    // @vuese
    // Used to fetch a single album along with its photos
    // @arg The album ID
    async removeAlbum (albumItem) {
      let albumIndex = this.selectedAlbums.findIndex(album => album.id === albumItem.id);
      if (albumIndex > -1) {
        this.finalAlbumList.splice(albumIndex, 1);
        this.selectedAlbums.splice(albumIndex, 1);
      }
      // Reset the current album
      if (this.currentAlbum !== null && albumIndex === this.currentAlbum) {
        this.currentAlbum = null;
      }
      if (this.selectedAlbums.length === this.Album.filter(x => x.type === 'Normal' && x.photo.length).length) {
        this.selectAllAlbumsVar = true;
      } else {
        this.selectAllAlbumsVar = false;          
      }
    },

    async getPhotos (albumId) {
      if (!this.AlbumPhoto[albumId]) {
        let { error, data } = await getOne('Album', albumId);
        if (error) {
          console.log('error', error);
        } else {
          const photos = [];
          for (let i = 0; i < data.photo.length; i++) {
            photos.push(data.photo[i].photo);
            data.photo[i].photo = data.photo[i].photo.id;
          }
          this.album = data;
          this.AlbumPhoto[albumId] = photos;
        }
      }
    },
    // @vuese
    // Used to add the selected photo(s)
    // @arg Selected photo ID
    async selectImage (albumItem, photo) {
      if (this.userSelectedImages.indexOf(photo.id) === -1) {
        this.userSelectedImages.push(photo.id);
        let index = this.finalAlbumList.findIndex(album => album.id === albumItem.id);
        if (index === -1) {
          let album = {
            id: albumItem.id,
            name: albumItem.name,
            photo: [{
              id: photo.id,
              caption: photo.caption ? photo.caption : '',
              thumb_url: photo.thumb_url,
              webview_url: photo.webview_url,
              original_url: photo.original_url
            }]
          };
          this.finalAlbumList.push(album);
        } else {
          let photoObj = {
            id: photo.id,
            caption: photo.caption ? photo.caption : '',
            thumb_url: photo.thumb_url,
            webview_url: photo.webview_url,
            original_url: photo.original_url
          };
          this.finalAlbumList[index].photo.push(photoObj);
          let photoLength = this.finalAlbumList[index].photo.length;
          if (this.photoList.length === photoLength && this.selectAll.indexOf(this.albumId) === -1) {
            this.selectAll.push(this.albumId);
          }
        }
        if (albumItem.photo.length === this.finalAlbumList[index].photo.length && this.selectAll.indexOf(albumItem.id) === -1) {
          this.selectAll.push(albumItem.id);
        }
      }
      // goTo(500, { duration: 300, offset: 0, easing: 'easeInOutCubic' });
    },
    // @vuese
    // Used to remove the selected photo(s)
    // @arg Selected photo ID
    unSelectImage (albumId, imageId) {
      // if (this.userSelectedImages.length <= 1) this.userSelectImages = false;
      if (this.userSelectedImages.indexOf(imageId) > -1) {
        this.userSelectedImages.splice(this.userSelectedImages.indexOf(imageId), 1);
        let albumIndex = this.finalAlbumList.findIndex(album => album.id === albumId);
        let photoIndex = this.finalAlbumList[albumIndex].photo.findIndex(img => img.id === imageId);
        this.finalAlbumList[albumIndex].photo.splice(photoIndex, 1);
        if (this.finalAlbumList[albumIndex].photo.length === 0) {
          this.finalAlbumList.splice(albumIndex, 1);
          this.selectedAlbums.splice(albumIndex, 1);
          // Reset the current album
          this.currentAlbum = null;
        }
        if (this.selectedAlbums.length === this.Album.filter(x => x.type === 'Normal' && x.photo.length).length) {
          this.selectAllAlbumsVar = true;
        } else {
          this.selectAllAlbumsVar = false;          
        }
        let allIndex = this.selectAll.indexOf(albumId);
        if (allIndex > -1) {
          this.selectAll.splice(allIndex, 1);
        }
      }
    }
  }
};
</script>

<style scoped>
#createVideo >>> .clickable {
  cursor: pointer;
}
#createVideo >>> .custom-title {
  color: #4b4b4b;
  font-size: 18px !important;
}

#createVideo >>> .backToAlbum {
    left: 30px;
    margin-top: 5px;
}

#createVideo >>> .handlerClass {
  right: 65px;
  top: 112px;
}

#createVideo >>> .accent--text {
    color: #019d8c !important;
    caret-color: #019d8c !important;
}

#createVideo >>> .v-input__slot {
    margin-bottom: 0px !important;
}

#createVideo >>> .v-messages {
    display: none !important;
}

 #createVideo >>> .primary {
    background-color: #7ac142 !important;
    border-color:#7ac142 !important;
}
.drag-icon {
    width: 25px;
    height: 25px;
    right: -10px;
    z-index: 1;
    top: -10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Video/create.vue